// 这是繁体中文语言对象

export default {
  index: '首頁',
  allContent: '全部內容',
  more: '更多',
  search: '搜尋',
  searchHistory: '搜尋記錄',
  hotSearchRanking: '熱搜排行',
  login: '登入',
  register: '註冊',
  myLikes: '我的喜歡',
  myCollections: '我的收藏',
  browsingHistory: '瀏覽記錄',
  myWallet: '我的錢包',
  mySupport: '我的支持',
  selectLanguage: '選擇語言',
  darkMode: '深色模式',
  settings: '設定',
  logout: '登出',
  afterLoginYouCan: '登入後你可以',
  collectFavoriteWorks: '收藏你喜歡的作品',
  joinDiscussions: '參與互動討論',
  viewBrowsingHistory: '查看瀏覽記錄',
  loginNow: '立即登入',
  firstTimeHere: '第一次來？',
  clickToRegister: '點我註冊',
  externalLink: '外部連結',
  pleaseEnterEmail: '請輸入郵箱地址',
  pleaseEnterPassword: '請輸入密碼',
  forgotPassword: '忘記密碼',
  readAndAgree: '已閱讀並同意',
  userAgreementWithBracket: '《使用者協議》',
  privacyPolicyWithBracket: '《隱私政策》',
  and: '和',
  copyright: 'Slash99 ©️2025 保留所有權利',
  aboutUs: '關於我們',
  userAgreement: '使用者協議',
  privacyPolicy: '隱私政策',
  passwordErrorRetry: '密碼錯誤，請重試',
  passwordErrorRemaining: '密碼錯誤，還剩{count}次機會',
  accountLockedHint: '帳號臨時鎖定，30分鐘後重試或透過郵箱找回密碼',
  passwordFormatError: '密碼格式不正確，請輸入8-20位包含字母和數字的密碼',
  pleaseAgreeAgreement: '請先同意使用者協議',
  pleaseEnterValidEmail: '請輸入有效的郵箱地址',
  loading: '加載中...',
  loginFailedCheckAccount: '登入失敗，請檢查郵箱和密碼',
  loginFailedServerDataError: '登入失敗：伺服器返回數據異常',
  loginSuccess: '登入成功',
  userBanned: '使用者已被封禁',
  emailNotVerified: '郵箱未驗證，請先驗證郵箱後再登入',
  tip: '提示',
  confirmClearSearchHistory: '確定要清除搜尋記錄嗎？',
  operationSuccess: '操作成功',
  changePassword: '修改密碼',
  setNewPasswordHint: '設定新密碼以保護您的帳戶安全',
  passwordRulePlaceholder: '8-20位密碼，含字母+數字',
  pleaseEnterPasswordAgain: '請再次輸入密碼',
  enterVerificationCode: '輸入驗證碼',
  resendAfterSeconds: 's後重發',
  sendVerificationCode: '發送驗證碼',
  emailFormatError: '郵箱地址不正確',
  passwordRuleDetail: '密碼需滿足：8-20位，含字母+數字',
  passwordMismatch: '密碼不一致',
  unableToGetEmail: '無法獲取使用者郵箱',
  sending: '發送中...',
  codeSentSuccess: '驗證碼已發送',
  sendCodeFailed: '發送驗證碼失敗',
  sendCodeFailedRetry: '發送驗證碼失敗，請稍後重試',
  verificationCodeLengthError: '驗證碼為4位',
  submitting: '修改中...',
  passwordResetSuccess: '密碼重置成功，請使用新密碼登入',
  passwordChangeFailed: '密碼修改失敗',
  passwordChangeFailedRetry: '修改密碼失敗，請稍後重試',
  featureUnderDevelopment: '功能開發中',
  nextStep: '下一步',
  seconds: '秒',
  codeSentToEmail: '驗證碼已發送到\n您的郵箱',
  verifying: '驗證中...',
  verificationCodeError: '驗證碼錯誤',
  codeSentToYourEmail: '驗證碼已發送到您的郵箱',
  emailAlreadyRegistered: '該郵箱已被註冊',
  pleaseSendVerificationCodeFirst: '請先點擊發送驗證碼',
  registering: '註冊中...',
  registerSuccess: '註冊成功',
  registerFailedRetry: '註冊失敗，請稍後重試',
  notSetYet: '暫未設置',
  confirmLogout: '確認退出',
  confirmLogoutMessage: '確定要退出登入嗎？',
  cancel: '取消',
  accountSettings: '賬戶設置',
  editProfile: '修改個人信息',
  redeemCode: '兌換碼',
  deleteAccount: '註銷賬戶',
  legalInfo: '法律信息',
  noContent: '暫無內容',
  paymentIconLoadFailed: '支付圖標加載失敗',
  footerCopyright: '© 2025-2026 slash99.com. All rights reserved.',
  // 个人资料编辑
  changeAvatar: '更換頭像',
  account: '帳號',
  nickname: '暱稱',
  pleaseEnterNickname: '請輸入暱稱',
  gender: '性別',
  save: '保存',
  selectGender: '選擇性別',
  male: '男',
  female: '女',
  secret: '保密',
  uploading: '上傳中...',
  uploadFailed: '上傳失敗',
  uploadFailedRetry: '上傳失敗，請稍後重試',
  chooseImageFailed: '選擇圖片失敗',
  updateAvatarError: '修改頭像異常',
  updateNicknameError: '修改暱稱異常',
  avatarUploadingPleaseWait: '頭像上傳中，請稍候',
  nicknameFormatError: '暱稱只支持漢字、英文、數字',
  nicknameLengthError: '暱稱最長10個漢字或20個英文',
  noChangesToSave: '沒有需要保存的更改',
  userIdNotExist: '用戶ID不存在',
  saving: '保存中...',
  saveSuccess: '保存成功',
  saveFailed: '保存失敗',
  saveFailedRetry: '保存失敗，請稍後重試',
  // 兑换码中心
  redeemCenter: '兌換中心',
  redeemSubtitle: '輸入兌換碼，獲取專屬權益',
  pleaseEnterRedeemCode: '請輸入兌換碼',
  paste: '粘貼',
  redeeming: '兌換中...',
  redeem: '兌換',
  redeemCodeTips: '兌換碼區分大小寫，請勿包含空格',
  redeemRecords: '兌換記錄',
  carrot: '胡蘿蔔',
  redFlower: '小紅花',
  noRedeemRecords: '暫無兌換記錄',
  goGetRedeemCode: '快去獲取兌換碼兌換吧',
  obtained: '獲得',
  pasteFailed: '粘貼失敗',
  pleaseManuallyEnterRedeemCode: '請手動輸入兌換碼',
  redeemLimitReached: '多次輸入無效兌換碼，已臨時限制兌換，10分鐘後可重試',
  redeemCodeFormatError: '兌換碼僅支持字母、數字和下劃線，請重新輸入',
  redeemSuccess: '對應權益成功發放至當前登錄帳號',
  redeemFailed: '兌換失敗',
  // 注销账户
  deleteAccountSubtitle: '註銷後所有數據將被永久刪除，且無法恢復',
  deleteAccountRelatedMatters: '申請註銷的關聯事項：',
  deleteAccountPoint1: '1.帳號處於安全狀態',
  deleteAccountDesc1: '帳號當前為正常使用狀態，不存在被盜、違規、禁用等風險',
  deleteAccountPoint2: '2.帳號資產已結清',
  deleteAccountDesc2: '帳號下的虛擬資產資源放棄，包括但不限於已購買的作品、帳戶餘額等',
  deleteAccountSecurityVerification: '註銷安全驗證',
  confirmDeleteAccount: '確認註銷',
  confirmDeleteAccountMessage: '註銷後所有數據將被永久刪除，且無法恢復。確定要繼續嗎？',
  confirmDelete: '確定註銷',
  processing: '處理中...',
  deleteAccountSuccess: '註銷成功',
  deleteAccountFailed: '註銷失敗',
  deleteAccountFailedRetry: '註銷失敗，請稍後重試',
  updatedDate: '更新日期：',
  loadFailed: '加載失敗',
  // 内容与我的喜欢
  noLikesYet: '暫無喜歡內容',
  goDiscoverLikes: '快去發現你喜歡的內容吧',
  thatsAllForNow: '暫時就是這些啦',
  today: '今天',
  yesterday: '昨天',
  earlier: '更早',
  author: '作者',
  shortStory: '短篇',
  novel: '小說',
  collection: '合集',
  posts: '動態',
  video: '視頻',
  videoFeed: '視頻動態',
  audioFeed: '音頻動態',
  ongoing: '更新中',
  completed: '已完結',
  noCollectionsYet: '暫無收藏的合集',
  goDiscoverCollections: '快去發現精彩的合集吧',
  noFavoritedPostsYet: '暫無收藏的動態',
  goCollectPosts: '快去收藏喜歡的動態吧',
  collectionLimitReached: '已達到收藏上限',
  noBrowsingHistoryYet: '暫無瀏覽記錄',
  goExploreContent: '快去探索精彩內容吧',
  purchased: '已購',
  subscribe: '訂閱',
  package: '套餐',
  live: '直播',
  accompaniedDays: '已陪伴TA',
  days: '天',
  andAlso: '還有',
  daysRemainingToExpire: '天到期',
  view: '查看',
  expired: '已過期',
  hasExpired: '已到期',
  resubscribe: '再次訂閱',
  noMore: '沒有更多了',
  noSubscriptionHistoryYet: '還沒有任何訂閱記錄哦～',
  noPurchaseHistoryYet: '還沒有任何購買記錄哦～',
  noLiveHistoryYet: '還沒有任何直播記錄哦～',
  noPurchasedCollectionsYet: '還沒有任何購買的合集哦～',
  copies: '份',
  upcoming: '待開播',
  living: '直播中',
  canEnterLiveRoom: '可進入直播間',
  liveInterruptedWaiting: '直播暫時中斷，等待恢復',
  liveEnded: '直播已結束',
  ticketPurchased: '已購本場直播門票',
  support: '支持',
  pleaseSelectSubscriptionPackage: '請選擇訂閱套餐',
  purchasing: '購買中...',
  purchaseSuccess: '購買成功',
  purchaseFailed: '購買失敗',
  user: '用戶',
  // 我的錢包與充值
  transactionRecord: '交易記錄',
  purchaseQuantity: '購買數量',
  quantity: '數量',
  paymentMethod: '支付方式',
  otherPaymentMethods: '其他支付方式',
  clickToSwitch: '點擊切換',
  rechargeProblemQuestion: '充值遇到問題？',
  userRechargeAgreementWithBracket: '《用戶充值協議》',
  recharge: '充值',
  rechargeSuccess: '充值成功',
  thisRecharge: '本次充值',
  creditedToAccount: '，到賬',
  carrots: '胡蘿蔔',
  problemQuestion: '遇到問題？',
  largeRechargeAmountLabel: '您本次充值金額為',
  confirmAmountCorrect: '請確認金額是否正確',
  noRefundAfterRecharge: '充值完成後將無法退款',
  confirm: '確認',
  scanAlipayQrTip: '請使用手機支付寶掃描二維碼支付',
  clickQrToLaunchAlipayTip: '手機可點擊二維碼喚起支付寶支付',
  clickToRefresh: '點擊刷新',
  qrCodeExpired: '二維碼已失效',
  paymentNotDetectedTip: '暫未檢測到支付，請完成支付後再刷新',
  back: '返回',
  paymentCompletedRefresh: '支付完成 刷新頁面',
  confirmingPaymentResult: '支付結果確認中',
  paymentNotSuccessfulRetryOrContact: '支付未成功，請重試或聯繫客服',
  paymentCancelled: '支付取消',
  paymentQueryTimeout: '支付結果查詢超時，請查看交易記錄',
  notLoggedIn: '未登錄',
  copySuccess: '複製成功',
  max99: '最大99',
  orderClosed: '訂單已關閉',
  pleaseAgreeRechargeAgreement: '請先勾選用戶充值協議',
  pleaseSelectQuantity: '請選擇數量',
  pleaseEnterQuantity: '請輸入數量',
  pleaseSelectPaymentMethod: '請選擇支付方式',
  paymentMethodNotSupported: '當前支付方式暫不支持充值',
  recharging: '充值中...',
  pleaseCheckPaymentInfo: '請檢查支付信息',
  cardFormLoadFailed: '銀行卡表單未加載，請檢查網絡後重試',
  rechargeFailed: '充值失敗',
  rechargeFailedRetry: '充值失敗，請稍後重試',
  paymentFailedRetry: '支付失敗，請稍後重試',
  paymentCancelledByUser: '已取消支付',
  pleaseCompleteRechargeAndInfo: '請先完成充值並填寫支付信息',
  paymentCredentialMissing: '支付憑證缺失，請重新點擊充值',
  paymentFailed: '支付失敗',
  pleaseCompletePaymentOperation: '請完成支付操作',
  paymentProcessing: '支付處理中',
  contentNotExist: '內容不存在',
  alipay: '支付寶',
  wechatPay: '微信支付',
  officialRechargeStore: '官方充值店舖',
  recent180DaysTip: '僅展示最近180天記錄',
  noTransactionRecordYet: '暫無交易記錄',
  rechargeOrConsumeTip: '快去充值或消費吧',
  loadMore: '繼續加載',
  platformGift: '平臺贈送',
  liveIncome: '直播收入',
  transaction: '交易',
  getTransactionRecordFailed: '獲取交易記錄失敗',
  loadFailedRetry: '加載失敗，請重試',
  // 首頁 Feed 與 Cookie
  recommendChrome: '推薦使用Chrome瀏覽器訪問',
  happeningNow: '正在發生',
  creatorsFreshIdeas: '創作者們新鮮出爐的想法與作品',
  viewFullText: '查看全文',
  unlockNow: '立即解鎖',
  follow: '關注',
  all: '全部',
  weUseCookies: '我們使用Cookie',
  cookieConsentDesc: '本網站使用 Cookie 來提升您的使用體驗、分析網站使用情況，並為您提供個性化廣告。點擊“全部接受”即表示您同意使用所有 Cookie。您也可以點擊“全部拒絕”或自定義您的偏好設置。',
  acceptAll: '全部接受',
  reject: '拒絕',
  swipeUpToLoadMore: '上滑加載更多',
  shareLinkCopied: '已複製分享鏈接',
  copyFailed: '複製失敗',
  subscriberOnlyContent: '本內容僅對訂閱者開放',
  unlockToViewFullContent: '解鎖查看完整內容',
  subscribeToUnlockPrefix: '訂閱',
  subscribeToUnlockSuffix: '即可解鎖',
  minCarrotsToUnlockPrefix: '最低',
  minCarrotsToUnlockSuffix: '胡蘿蔔 可解鎖內容',
  purchaseCollectionToUnlock: '購買合集即可解鎖',
  cannotPlay: '無法播放',
  contentIncomplete: '內容信息不完整',
  followed: '已關注',
  followFailed: '關注失敗',
  operationFailed: '操作失敗',
  creator: '創作者',
  roomIdNotExist: '房間ID不存在',
  liveStatusAbnormal: '直播狀態異常',
  getLiveRoomInfoFailed: '獲取直播間信息失敗',
  networkErrorRetry: '網絡異常，請稍後重試',
  liveReminderSet: '已設置開播提醒',
  followSuccess: '關注成功',
  feedChannel: '動態頻道',
  // 活動專題
  popularityRanking: '人氣榜',
  cpRanking: 'CP榜',
  sendFlowers: '去送花',
  rankingDataNotExist: '榜單數據不存在',
  topContribution: '貢獻TOP',
  rushToGrab: '速來搶占',
  notConfigured: '暫未配置',
  getArticleFailed: '獲取文章失敗',
  activityTopic: '活動專題',
  tenThousand: '萬',
  hundredMillion: '億',
  // 个人中心 profile
  myProfile: '個人主頁',
  confirmDeletePost: '確認刪除',
  deletePostConfirmMessage: '確定要刪除這條內容嗎？刪除後將無法恢復。',
  likes: '喜歡',
  collections: '收藏',
  history: '足跡',
  creationCenter: '創作中心',
  contactCustomerService: '聯繫客服',
  edit: '編輯',
  noRelatedContentFound: '沒有找到相關內容',
  delete: '刪除',
  creation: '創作',
  wallet: '錢包',
  customerService: '客服',
  startBroadcast: '開播',
  copyEmailSuccess: '複製郵箱成功',
  openInBrowserTip: '請在電腦瀏覽器上打開，以獲得最佳體驗',
  addressCopiedTip: '地址已複製\n請在電腦瀏覽器上打開\n以獲得最佳體驗',
  addressCopied: '地址已複製',
  pleaseOpenInDesktopBrowser: '請在電腦瀏覽器上打開',
  forBestExperience: '以獲得最佳體驗',
  articleInfoIncomplete: '文章信息不完整',
  collectionInfoIncomplete: '合集信息不完整',
  pleaseLoginFirst: '請先登入',
  operationFailedRetry: '操作失敗，請稍後重試',
  postIdNotExist: '動態ID不存在',
  deleteSuccess: '刪除成功',
  deleteFailed: '刪除失敗',
  justNow: '剛剛',
  minutesAgo: '分鐘前',
  daysAgo: '天前',
  tomorrow: '明天',
  daysLater: '天後',
  // 合集导航 CollectionNavigation
  catalog: '目錄',
  nextChapter: '下一章',
  previousChapter: '上一章',
  // 数量选择器 PcmQuantitySelector
  quickSelect: '一鍵速選',
  customQuantity: '自定義數量',
  // 视频详情页 video-detail
  videoUnavailableOrDeleted: '視頻不存在或已下架',
  backToHomeForMore: '返回首頁看看其他精彩內容吧',
  expand: '展開',
  collapse: '收起',
  lastEditedAt: '最後一次編輯於',
  actors: '出鏡',
  creationTeam: '創作團隊',
  comments: '評論',
  reply: '回復',
  replyToPrefix: "回復 {'@'}",
  expandMoreReplies: '展開更多回復',
  collapseReplies: '收起回復',
  leaveYourThoughts: '留下你的感受',
  send: '發送',
  favorited: '已收藏',
  favoriteCollection: '收藏合集',
  nothingHere: '這裡什麼都沒有呢',
  collapseCatalog: '收起目錄',
  goodsIdCannotBeEmpty: '商品ID不能為空',
  packageIdCannotBeEmpty: '套餐ID不能為空',
  collectionIdCannotBeEmpty: '合集ID不能為空',
  purchaseFailedRetry: '購買失敗，請稍後重試',
  purchaseFailedRetryShort: '購買失敗，請重試',
  nextEpisodeRequiresUnlock: '下一集需要解鎖',
  alreadyLastEpisode: '已經是最後一集了',
  autoPlayFailed: '自動播放失敗',
  copyLinkSuccess: '複製鏈接成功',
  article: '文章',
  picture: '圖片',
  wordsCountUnit: '字',
  commentSendSuccess: '評論發送成功',
  // 他人主页 user-profile
  acknowledgements: '致謝',
  alreadyHave: '已有 ',
  peopleSupported: '人支持',
  subscribeToUser: '訂閱TA',
  subscribed: '已訂閱',
  duringValidityPeriod: '有效期內',
  fansCircleContentUnlock: '粉絲圈內容限時解鎖',
  slashUser: 'Slash用戶',
  userInfoIncomplete: '用戶信息不完整',
  cannotFollowSelf: '不能關注自己',
  unfollowed: '已取消關注',
  dayUnit: '天',
  enter: '進入',
  // 简剧/短篇 short-story
  noCreationTeam: '暫無創作團隊',
  goToNextStory: '進入下一篇',
  noDeletePermission: '無刪除權限',
  previewImageFailed: '預覽圖片失敗',
  authorInfoIncomplete: '作者資訊不完整',
  pleaseEnterComment: '請輸入評論內容',
  commentIdCannotBeEmpty: '評論ID不能為空',
  postCommentFailed: '發表評論失敗',
  unfavorited: '已取消收藏',
  liked: '已點讚',
  unliked: '已取消點讚',
  commentInfoIncomplete: '評論資訊不完整',
  replyInfoIncomplete: '回覆資訊不完整',
  unfollowFailed: '取消關注失敗',
  alreadyLastStory: '已經是最後一篇了',
  nextStoryNotFound: '未找到下一篇文章',
  noMoreStories: '暫無更多文章',
  // 小说详情 novel-detail
  alreadyLastChapter: '已經是最後一章了',
  nextChapterRequiresUnlock: '下一章需要解鎖',
  jumpFailed: '跳轉失敗',
  alreadyFirstChapter: '已經是第一章了',
  favoriteSuccess: '收藏成功',
  unfavoriteSuccess: '取消收藏成功',
  collectionAlreadyFavorited: '該合集已收藏',
  collectionNotFavorited: '該合集未收藏',
  collectionIdNotExist: '合集ID不存在',
  getCollectionDetailFailed: '獲取合集詳情失敗',
  getChapterListFailed: '獲取章節列表失敗',
  noChaptersInCollection: '該合集暫無章節',
  // 搜索结果 search-result
  searchPlaceholder: '搜尋你想看的內容',
  comprehensive: '綜合',
  noRelatedContent: '未找到相關內容',
  tryOtherKeywords: '試試其他關鍵字吧',
  pleaseEnterSearchContent: '請輸入搜尋內容',
  searchFailedRetry: '搜尋失敗，請稍後重試',
  searchUserFailedRetry: '搜尋用戶失敗，請稍後重試',
  confirmDeleteSearchHistory: '確定要刪除搜尋記錄嗎？',
  cleared: '已清空',
  // 重置密码 reset-password
  currentAccountLabel: '目前帳號：',
  pleaseGetCodeFirst: '請先獲取驗證碼',
  verificationExpired: '驗證資訊已過期，請重新獲取驗證碼',
  passwordChangeSuccess: '密碼修改成功',
  modifying: '修改中...',
  passwordChangeFailedRetryLong: '密碼修改失敗，請稍後重試',
  // 首页 index
  viewAll: '...查看全部',
  reachedTheEnd: '到底啦',
  likeToWatch: '喜歡看',
  swipeUpToPlay: '向上滑播放',
  swipeUpIconText: '👆 向上滑',
  swipeLeftRight: '左右劃',
  switchContent: '切換內容',
  swipeIconText: '👈 滑動 👉',
  ageVerification: '年齡驗證',
  areYou18YearsOld: '請問您是否年滿18週歲',
  adultContentWarning: 'Slash99.com包含成人內容，請您確認自己是否已滿18歲。未滿18歲訪問本網站將受到所在國家或地區法律法規的限制。',
  leave: '離開',
  yesIm18: '是的，我已滿18週歲',
  loginOrRegister: '登入 / 註冊',
  editorChoice: '編輯精選',
  livePreview: '直播預告',
  enterLiveRoom: '進入直播間',
  refreshBatch: '換一換',
  stayTuned: '敬請期待',
  loggedOut: '已退出登入',
  liveRoomInfoIncomplete: '直播間資訊不完整',
  loadUserInfoFailed: '載入用戶資訊失敗',
  postInfoIncomplete: '動態資訊不完整',
  videoLoadFailed: '影片載入失敗',
  dataAnomaly: '資料異常',
  // 分类与组件 category / components
  noRelatedContentCategory: '暫無相關內容',
  tryAnotherCategory: '換個分類看看吧',
  filterTags: '篩選標籤',
  containsAnyOneTag: '包含任意1個標籤',
  clear: '清空',
  confirmSelect: '確定',
  modifyFilter: '修改篩選',
  maxThreeTags: '最多只能選擇3個標籤',
  acknowledgementsList: '致謝列表',
  noSupportersYet: '暫無支持者',
  alreadyHaveShort: '已有',
  // 评论与支付 comments / alipay
  paymentSuccess: '支付成功',
  envNotSupportAutoAlipay: '當前環境不支援自動開啟支付寶',
  repliesCountSuffix: '條回覆',
  share: '分享',
  viewAllReplies: '查看全部回覆',
  footerList: {
    about: '關於',
    userAgreement: '用戶協議',
    privacyPolicy: '隱私政策',
    aboutUs: '關於我們',
    contactUs: '聯繫我們',
    feedback: '問題反饋',
    submission: '投稿',
    otherMatters: '其他事項',
    returnPolicy: '退換貨政策',
    intellectualProperty: '知識產權',
    help: '幫助',
    '关于': '關於',
    '用户协议': '用戶協議',
    '隐私政策': '隱私政策',
    '关于我们': '關於我們',
    '联系我们': '聯繫我們',
    '问题反馈': '問題反饋',
    '投稿': '投稿',
    '其他事项': '其他事項',
    '退换货政策': '退換貨政策',
    '知识产权': '知識產權',
    '帮助': '幫助',
  },
  userDrawer: { // 抽屜導航
    language: [
      { name: '簡體中文' },
      { name: '繁體中文' },
      { name: '英文' },
      { name: '俄語' },
      { name: '法文' },
      { name: '泰語' },
      { name: '老撾語' },
    ],
    contest: '營銷大賽',
  },
  tabbar: {
    data: {
      'tab1': '首頁',
    },
  },
  page: {
    contest: {
      applyFailed: '報名失敗'
    },
  }
,
  poorNetworkSwitchQuality: '當前網絡環境較差，建議切換清晰度',
  loadFailedPleaseRefresh: '加載失敗，請刷新頁面重試',
  refresh: '刷新',
  definition: '清晰度',
  autoQuality: '自動',
  playbackSpeed: '倍速',
  subtitle: '字幕',
  translate: '翻譯',
  becomeSupporter: '成為支持者',
  fansCircleBenefits: '粉絲圈權益',
  inventoryColon: '庫存：',
  month: '月',
  insufficientBalanceGoRecharge: '餘額不足，去充值',
  noPurchasableOptions: '暫無可購買選項',
  fansBadge: '粉絲標識',
  officialEventsPriority: '官方活動優先參加',
  purchaseBonus: '購買加贈',
  home: '主頁',
  my: '我的',
  listing: '上架中',
  supportCreator: '支持創作者',
  goodsListing: '商品上架中',
  toUnlockContent: '即可解鎖內容',
  purchaseCollection: '購買合集',
  quarter: '季',
  year: '年',
  total: '合計',
  notContainCurrentContent: '不含當前內容',
  price: '價格',
  buy: '購買',
  noPurchasablePackages: '暫無可購買套餐',
  selectGifting: '選擇送禮',
  pleaseSelectTwoPersons: '請選擇兩個人',
  sendToColon: '送給：',
  singlePerson: '單人',
  cp: 'CP',
  selectTwoPersons: '選擇兩個人',
  insufficientInventoryGoGet: '庫存不足，去獲得',
  sendOut: '送出',
  pleaseSelectRecipient: '請選擇送禮對象',
  sendingOut: '送出中...',
  sendFlowerSuccess: '送花成功',
  sendFlowerFailedRetry: '送花失敗，請重試',
  paramsError: '參數錯誤',
  contentDetail: '內容詳情',
  lightMode: '淺色模式',
  // 直播间多语言 (Live stream i18n)
  onlineUsers: "在線用戶",
  currentContributionRank: "本場貢獻榜",
  noOnlineUsers: "暫無在線用戶",
  noContributionRecord: "本場暫無貢獻記錄",
  contributionTipDesc: "點贊、發彈幕、分享或送禮，都可以增加本場貢獻值。",
  giveGift: "送禮",
  sendGift: "送禮物",
  liveInterruptedTemp: "直播暫時中斷",
  streamerRecoveringTip: "主播正在嘗試恢復，請稍後再試",
  purchasedBenefitsRetained: "已購權益保留，無需重複購買",
  liveInterruptedCannotBuy: "直播暫時中斷，當前暫不可購買",
  liveStreamAbnormal: "本場直播異常",
  backToHome: "返回首頁",
  liveStreamEnded: "本場直播已結束",
  liveRoomLoading: "直播間加載中...",
  retry: "重試",
  startedBroadcast: "已開播",
  livingNow: "正在直播",
  chat: "聊天",
  buyAfterLiveResume: "直播恢復後可購買",
  chatAfterLiveResume: "直播恢復後可繼續互動",
  canChatAfterPurchase: "購買後可發送彈幕",
  canChatAfterPurchaseNotice: "購買後即可發送彈幕",
  supportWithDanmaku: "彈幕支持下～",
  exitClearScreen: "退出清屏",
  clearScreen: "清屏",
  feedbackProblem: "反饋問題",
  clickToPlay: "點擊播放",
  feedbackProblemTitle: "問題反饋",
  describeFeedback: "描述反饋",
  describeProblemPlaceholder: "請描述你遇到的問題...",
  uploadScreenshot: "上傳截圖",
  optional: "選填",
  add: "添加",
  submitFeedback: "提交反饋",
  give: "贈送",
  liveNotStarted: "直播尚未開始",
  liveAbnormal: "直播異常",
  liveInterrupted: "直播已中斷",
  playbackFailedRetry: "播放失敗，請手動重試",
  switchingQuality: "切換清晰度中...",
  contributionDescTitle: "貢獻值說明",
  contributionDetailDesc: "貢獻值用於衡量你在本場直播中的支持與互動情況。觀看直播、參與互動、贈送禮物、分享直播等行為，都可能提升你的貢獻值。不同互動行為對貢獻值的影響有所不同，具體以實際展示為準。",
  totalPeopleCount: "共 {count} 人",
  userDefault: "用戶",
  me: "我",
  gapToBeSurpassed: "距被超越還差{gap}貢獻值",
  gapToSurpassPrevious: "距超越上一名還差{gap}貢獻值",
  gapToGetRanked: "距有排名還差{gap}貢獻值",
  loginToWatchAndInteract: "登錄後觀看直播並參與互動",
  loginSlashRegister: "登錄 / 註冊",
  startBroadcastAt: "{time} 開播",
  hasAccessDirectWatch: "已獲得權益·開播後可直接觀看",
  unlockToWatchLiveAndChat: "解鎖後可觀看直播畫面與彈幕互動",
  saleStartBroadcastAt: "售賣 · {time} 開播",
  buyThisLiveStream: "{price} 購買本場",
  fullscreen: "全屏",
  senderSentGiftCombo: "{sender} 送出 {gift} ×{count}",
  comboCountText: "{count}連擊!",
  combo: "連擊",
  insufficientBalance: "餘額不足",
  giftBalanceModalMsg: "本次贈送需{cost}，當前餘額{balance}。",
  goRecharge: "去充值",
  loginToInteractNotice: "觀看直播、發彈幕、送禮物、看貢獻榜需先登錄",
  loginToViewChat: "登錄後查看彈幕、參與互動",
  platformNotice: "平台提示",
  hostAnnouncement: "主播公告",
  streamerNotStartedChatNotice: "主播還未開播，開播後彈幕將在此展示",
  sendFailedRetry: "發送失敗，請重試",
  loginToChatPlaceholder: "登錄後參與聊天",
  notStartedCannotSend: "暫未開播，暫不可發送",
  messagesFailedClickRetry: "{count} 條消息發送失敗，點擊重發",
  favoriteProgramList: "收藏節目單",
  stillNeed: "還差",
  sentDot: "贈送 · ",
  sent: "送出",
  sessionNotExist: "場次信息不存在",
  insufficientCarrotRechargeConfirm: "胡蘿蔔餘額不足，是否前往充值？",
  danmakuMax50Words: "彈幕最多 50 字",
  mutedByHostCannotChat: "你已被主播禁言，暫時無法發送彈幕",
  chatServiceConnecting: "聊天服務連接中，請稍後重試",
  networkDisconnectedCheck: "網絡已斷開，請檢查網絡連接",
  connectionDisconnectedReconnecting: "連接已斷開，正在嘗試重連...",
  kickedOutReconnecting: "被踢出，正在重連...",
  insufficientCarrotsComboStopped: "胡蘿蔔不足，連擊已停止",
  sendGiftSuccessCelebration: "🎉 贈送成功",
  giftOffShelfComboStopped: "禮物已下架，連擊已停止",
  giftOffShelf: "禮物已下架",
  liveInterruptedCannotGift: "直播信號中斷，暫時無法送禮",
  notStartedCannotGift: "暫未開播，暫不可送禮",
  giftSendSuccess: "禮物發送成功",
  likeFailed: "點贊失敗",
  linkCopied: "鏈接已複製",
  copyFailedRetry: "複製失敗，請重試",
  shareFailedRetry: "分享失敗，請重試",
  screenCleared: "已清屏",
  screenRestored: "已恢復",
  linkCopiedOpenBrowser: "鏈接已複製，請在瀏覽器中打開",
  screenshotAdded: "截圖已添加",
  feedbackSubmitSuccess: "反饋提交成功",
  liveStreamCannotWatchRefresh: "直播暫時無法觀看，請稍後刷新試試",
  favoritedCollection: "已收藏合集",
  unfavoritedCollection: "已取消收藏",
  userEnteredLiveRoom: "進入了直播間",
  userFollowedHost: "關注了主播",
  userLikedHost: "給主播點了喜歡 ❤️",
  anonymous: "匿名",
  orientationCacheCleared: "已清除方向緩存，刷新後重新檢測",
  todayWithTime: "今天 {time}",
  tomorrowWithTime: "明天 {time}",
  dayAfterTomorrowWithTime: "後天 {time}",
  monthDayTime: "{month}月{day}日 {time}",
  postedLivePreview: "發布了直播預告",
  watchingCount: "{count}在看",
  defaultLivingTitle: "今晚陪你聊聊那些故事",
  defaultPreviewTitle: "明日預告：千古世界探秘",
  postCountUnit: "{count}個動態",
  wordsCount: "{count}字",
  tenThousandWordsCount: "{count}萬字",
  qualityUltra: "超清",
  qualityHigh: "高清",
  qualityStandard: "標清",
  qualitySmooth: "流暢",
  subtitleBilingual: "🌐 中文 + English",
  subtitleEnglishOnly: "English",
  subtitleOff: "關閉",
  "在线用户": "在線用戶",
  "本场贡献榜": "本場貢獻榜",
  "暂无在线用户": "暫無在線用戶",
  "本场暂无贡献记录": "本場暫無貢獻記錄",
  "点赞、发弹幕、分享或送礼，都可以增加本场贡献值。": "點贊、發彈幕、分享或送禮，都可以增加本場貢獻值。",
  "送礼": "送禮",
  "送礼物": "送禮物",
  "直播暂时中断": "直播暫時中斷",
  "主播正在尝试恢复，请稍后再试": "主播正在嘗試恢復，請稍後再試",
  "已购权益保留，无需重复购买": "已購權益保留，無需重複購買",
  "直播暂时中断，当前暂不可购买": "直播暫時中斷，當前暫不可購買",
  "本场直播异常": "本場直播異常",
  "返回首页": "返回首頁",
  "本场直播已结束": "本場直播已結束",
  "直播间加载中...": "直播間加載中...",
  "重试": "重試",
  "直播中": "直播中",
  "已开播": "已開播",
  "已关注": "已關注",
  "关注": "關注",
  "正在直播": "正在直播",
  "进入": "進入",
  "全部": "全部",
  "聊天": "聊天",
  "直播恢复后可购买": "直播恢復後可購買",
  "直播恢复后可继续互动": "直播恢復後可繼續互動",
  "购买后可发送弹幕": "購買後可發送彈幕",
  "购买后即可发送弹幕": "購買後即可發送彈幕",
  "弹幕支持下～": "彈幕支持下～",
  "发送": "發送",
  "清晰度": "清晰度",
  "退出清屏": "退出清屏",
  "清屏": "清屏",
  "反馈问题": "反饋問題",
  "点击播放": "點擊播放",
  "描述反馈": "描述反饋",
  "请描述你遇到的问题...": "請描述你遇到的問題...",
  "上传截图": "上傳截圖",
  "选填": "選填",
  "添加": "添加",
  "提交中...": "提交中...",
  "提交反馈": "提交反饋",
  "充值": "充值",
  "赠送": "贈送",
  "房间ID不存在": "房間ID不存在",
  "加载失败": "加載失敗",
  "直播尚未开始": "直播尚未開始",
  "直播异常": "直播異常",
  "直播已中断": "直播已中斷",
  "播放失败，请手动重试": "播放失敗，請手動重試",
  "切换清晰度中...": "切換清晰度中...",
  "贡献值说明": "貢獻值說明",
  "贡献值用于衡量你在本场直播中的支持与互动情况。观看直播、参与互动、赠送礼物、分享直播等行为，都可能提升你的贡献值。不同互动行为对贡献值的影响有所不同，具体以实际展示为准。": "貢獻值用於衡量你在本場直播中的支持與互動情況。觀看直播、參與互動、贈送禮物、分享直播等行為，都可能提升你的貢獻值。不同互動行為對貢獻值的影響有所不同，具體以實際展示為準。",
  "共 {count} 人": "共 {count} 人",
  "用户": "用戶",
  "我": "我",
  "距被超越还差{gap}贡献值": "距被超越還差{gap}貢獻值",
  "距超越上一名还差{gap}贡献值": "距超越上一名還差{gap}貢獻值",
  "距有排名还差{gap}贡献值": "距有排名還差{gap}貢獻值",
  "登录后观看直播并参与互动": "登錄後觀看直播並參與互動",
  "登录 / 注册": "登錄 / 註冊",
  "直播预告": "直播預告",
  "{time} 开播": "{time} 開播",
  "已获得权益·开播后可直接观看": "已獲得權益·開播後可直接觀看",
  "解锁后可观看直播画面与弹幕互动": "解鎖後可觀看直播畫面與彈幕互動",
  "售卖 · {time} 开播": "售賣 · {time} 開播",
  "{price} 购买本场": "{price} 購買本場",
  "全屏": "全屏",
  "{sender} 送出 {gift} ×{count}": "{sender} 送出 {gift} ×{count}",
  "{count}连击!": "{count}連擊!",
  "连击": "連擊",
  "余额不足": "餘額不足",
  "余额不足，去充值": "餘額不足，去充值",
  "本次赠送需{cost}，当前余额{balance}。": "本次贈送需{cost}，當前餘額{balance}。",
  "去充值": "去充值",
  "观看直播、发弹幕、送礼物、看贡献榜需先登录": "觀看直播、發彈幕、送禮物、看貢獻榜需先登錄",
  "登录后查看弹幕、参与互动": "登錄後查看彈幕、參與互動",
  "平台提示": "平台提示",
  "主播公告": "主播公告",
  "主播还未开播，开播后弹幕将在此展示": "主播還未開播，開播後彈幕將在此展示",
  "发送失败，请重试": "發送失敗，請重試",
  "登录后参与聊天": "登錄後參與聊天",
  "暂未开播，暂不可发送": "暫未開播，暫不可發送",
  "{count} 条消息发送失败，点击重发": "{count} 條消息發送失敗，點擊重發",
  "已收藏": "已收藏",
  "收藏节目单": "收藏節目單",
  "这里什么都没有呢": "這裡什麼都沒有呢",
  "收起目录": "收起目錄",
  "还差": "還差",
  "赠送 · ": "贈送 · ",
  "送出": "送出",
  "场次信息不存在": "場次信息不存在",
  "胡萝卜余额不足，是否前往充值？": "胡蘿蔔餘額不足，是否前往充值？",
  "弹幕最多 50 字": "彈幕最多 50 字",
  "你已被主播禁言，暂时无法发送弹幕": "你已被主播禁言，暫時無法發送彈幕",
  "聊天服务连接中，请稍后重试": "聊天服務連接中，請稍後重試",
  "网络已断开，请检查网络连接": "網絡已斷開，請檢查網絡連接",
  "连接已断开，正在尝试重连...": "連接已斷開，正在嘗試重連...",
  "被踢出，正在重连...": "被踢出，正在重連...",
  "胡萝卜不足，连击已停止": "胡蘿蔔不足，連擊已停止",
  "🎉 赠送成功": "🎉 贈送成功",
  "礼物已下架，连击已停止": "禮物已下架，連擊已停止",
  "礼物已下架": "禮物已下架",
  "直播信号中断，暂时无法送礼": "直播信號中斷，暫時無法送禮",
  "暂未开播，暂不可送礼": "暫未開播，暫不可送禮",
  "礼物发送成功": "禮物發送成功",
  "点赞失败": "點贊失敗",
  "链接已复制": "鏈接已複製",
  "复制失败，请重试": "複製失敗，請重試",
  "分享失败，请重试": "分享失敗，請重試",
  "已清屏": "已清屏",
  "已恢复": "已恢復",
  "链接已复制，请在浏览器中打开": "鏈接已複製，請在瀏覽器中打開",
  "截图已添加": "截圖已添加",
  "反馈提交成功": "反饋提交成功",
  "直播暂时无法观看，请稍后刷新试试": "直播暫時無法觀看，請稍後刷新試試",
  "已收藏合集": "已收藏合集",
  "已取消收藏": "已取消收藏",
  "进入了直播间": "進入了直播間",
  "关注了主播": "關注了主播",
  "给主播点了喜欢 ❤️": "給主播點了喜歡 ❤️",
  "匿名": "匿名",
  "已清除方向缓存，刷新后重新检测": "已清除方向緩存，刷新後重新檢測",
  "今天 {time}": "今天 {time}",
  "明天 {time}": "明天 {time}",
  "超清": "超清",
  "高清": "高清",
  "标清": "標清",
  "流畅": "流暢",
  sale: "售賣",
  "售卖": "售賣",
  buyThisTicket: "購買本場",
  "购买本场": "購買本場",
  costForGiftColon: "本次贈送需",
  "本次赠送需": "本次贈送需",
  currentBalanceColon: "，當前餘額",
  "，当前余额": "，當前餘額",
  period: "。",
  "。": "。",
  submitFailed: "提交失敗",
  selectedChapterColon: "已選擇：",
  "已选择：": "已選擇：",
  kickedOut: "被踢出",
  "被踢出": "被踢出",
  connectionDisconnected: "連線中斷",
  "连接断开": "連線中斷",
  reconnectingNotice: "{reason}，正在重新連線...",
  "{reason}，正在重连...": "{reason}，正在重新連線...",
  gift: "禮物",
  "礼物": "禮物",
  "视频": "影片",
  varietyShow: "綜藝",
  "综艺": "綜藝",
  playback: "回放",
  "回放": "回放",
  ended: "已結束",
  "已结束": "已結束",
  originalQuality: "原畫",
  "原画": "原畫",
  "自动": "自動",
  blurayQuality: "藍光",
  "蓝光": "藍光",
  standardPlusQuality: "標強",
  "标强": "標強",
  hot: "熱門",
  "热门": "熱門",
  cheap: "便宜",
  "便宜": "便宜",
  premium: "高級",
  "高级": "高級",
  "发布了直播预告": "發布了直播預告",
  "今晚陪你聊聊那些故事": "今晚陪你聊聊那些故事",
  "明日预告：千古世界探秘": "明日預告：千古世界探秘",
  "账号不能为空": "帳號不能為空",
  "1小时内最多发送{count}次验证码，请{minutes}分钟后再试": "1小時內最多發送{count}次驗證碼，請{minutes}分鐘後再試",
  hottest: "最熱",
  latest: "最新",
  "最热": "最熱",
  "最新": "最新",
  newest: "最新",
  pureLove: "純愛",
  lily: "百合",
  ceo: "霸道總裁",
  lady: "大小姐",
  detective: "偵探",
  "月": "月",
  "季": "季",
  "年": "年",
  "天": "天"
};
